import { COLORS } from 'src/theme/palette';
import { makeStyles } from 'src/utils/makeStyles';

const styles = makeStyles({
  timeTextField: {
    height: '20px',
    minWidth: 0,
    margin: 0,
  },
  select: {
    height: '20px',
    padding: 0,
    borderRadius: 0,
    boxShadow: 'none',
    backgroundColor: 'transparent',
    '&.Mui-focused, &.Mui-error, &.Mui-focused.Mui-error': {
      boxShadow: 'none',
    },
    '&.Mui-error': {
      color: COLORS.red100,
    },
  },
  selectInput: {
    padding: '0 !important',
    height: '20px !important',
    minHeight: '20px !important',
  },
  selectMenu: {
    maxHeight: '170px',
    '& ul': {
      minWidth: 0,
    },
    '& li': {
      minHeight: 'auto',
      padding: '5px 15px',
      justifyContent: 'center',
    },
  },
  poSelect: {
    '& .MuiSelect-select': {
      textAlign: 'left',
    },
    '& .MuiSelect-icon': {
      top: '50%',
      transform: 'translateY(-50%)',
    },
  },
  poSelectMenu: {
    '& ul': {
      padding: 0,
    },
    '& li': {
      minHeight: 'auto',
      padding: '4px 8px',
    },
  },
  poSelectReadOnly: {
    '& .MuiSelect-select': {
      cursor: 'default',
    },
    '& .MuiSelect-icon': {
      display: 'none',
    },
  },
  poSelectDisabledValue: {
    color: COLORS.black100,
  },
  readOnly: {
    pointerEvents: 'none',
  },
});

export default styles;
